import React from 'react';
import {useTranslation} from 'react-i18next';
import {ReactComponent as SendIcon} from '../assets/send_icon.svg';
import {ReactComponent as ArrowDown} from '../../../icons/round-arrow_drop_down.svg';
import {useDispatch, useSelector} from "react-redux";
import {couponTypeArray, StoreType} from "../../../../store/spirs/types";
import {COPY_EVENT_TO_COUPON_TYPE, couponType, MOVE_EVENT_TO_COUPON_TYPE} from "../../../../store/spirs/actions";

interface ActionProps {
    isOrdinar: boolean;
    selectionId?: number;
    fixtureId?: number;
}

const actionTypes = ['moveTo', 'copyTo'] as const;

type actionType = typeof actionTypes[number];

function Actions(props: ActionProps) {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const currentCouponType = useSelector((state: StoreType) => state.spirs.coupons.currentCouponType);

    const [values, setValues] = React.useState<{
        selectedAction: actionType;
        selectedCouponType: couponType
    }>({
        selectedAction: 'moveTo',
        selectedCouponType: couponTypeArray.filter((ct) => currentCouponType !== ct)[0]
    });

    function handleClick() {
        if (props.selectionId && props.fixtureId) {
            switch (values.selectedAction) {
                case 'moveTo':
                    dispatch(MOVE_EVENT_TO_COUPON_TYPE(props.fixtureId, props.selectionId, values.selectedCouponType));
                    break;
                case 'copyTo':
                    dispatch(COPY_EVENT_TO_COUPON_TYPE(props.fixtureId, props.selectionId, values.selectedCouponType));
                    break;
            }
        }
    }

    return (
        <div className="grid max-tablet:grid-cols-1 tablet:grid-cols-[1fr_1fr_42px]">
            <div className="relative">
                <select
                    onChange={(e) => setValues(prevState => ({
                        ...prevState,
                        selectedAction: e.target.value as actionType
                    }))}
                    name="Bob"
                    className="border-t-[1px] tablet:border-r-[1px] tablet:border-b-[1px] border-[#171A1E] bg-[#36404A] focus:outline-none text-[12px]
                    desktop:text-[16px] font-['Roboto'] leading-[100%] py-[13px] px-2.5 desktop:px-[16px] appearance-none w-full text-white"
                    value={values.selectedAction}
                >
                    {actionTypes.map((actionTypeVal, index) =>
                        <option
                            key={index}
                            className="border-t border-[#171A1E] text-[16px] desktop:text-[16px] font-['Roboto'] leading-[100%] text-white"
                            value={actionTypeVal}
                        >
                            {t('coupons.actions.' + actionTypeVal)}
                        </option>
                    )}
                </select>

                <span className="pointer-events-none absolute right-[18px] top-[40%] -translate-y-1/2 flex items-center">
                  <ArrowDown className="w-4 h-4 text-white"/>
                </span>
            </div>

            <div className="relative">
                <select
                    onChange={(e) => setValues(prevState => ({
                        ...prevState,
                        selectedCouponType: e.target.value as couponType
                    }))}
                    name="age"
                    className="border-t-[1px] tablet:border-r-[1px] tablet:border-b-[1px] border-[#171A1E] bg-[#36404A] text-[12px] focus:outline-none
                    desktop:text-[16px] font-['Roboto'] leading-[100%] py-[13px] px-2.5 desktop:px-[16px] appearance-none w-full text-white"
                    value={values.selectedCouponType}
                >

                    {couponTypeArray
                        .filter(couponTypeVal => couponTypeVal !== currentCouponType)
                        .map((couponTypeVal, index) =>
                            <option
                                key={index}
                                className="border-t-[1px] border-r-[1px] border-[#171A1E] text-[16px] desktop:text-[16px] font-['Roboto'] leading-[100%] text-white"
                                value={couponTypeVal}
                            >
                                {t('coupons.' + couponTypeVal + '.tabTitle')}
                            </option>
                        )}
                </select>
                <span className="pointer-events-none absolute right-[18px] top-[40%] -translate-y-1/2 flex items-center">
                  <ArrowDown className="w-4 h-4 text-white"/>
                </span>
            </div>
            <div
                onClick={handleClick}
                className="flex items-center justify-center cursor-pointer max-desktop:h-[40px] desktop:h-[44px] bg-[#147FB2] w-full border-t-[1px] border-b-[1px] border-[#171A1E]"
            >
                <SendIcon/>
            </div>
        </div>
    );
}

export default Actions;
